export default "__VITE_ASSET__C0b3djUr__"